import React from 'react';
import { ButtonWithAnchor } from '../../income-tax/page-sections/hero-section/sticky-button';
import { ButtonVariants } from '../../Atoms/Button';

interface CouponCardProps {
  title: string;
  couponCode: string;
  validTill: string;
  buyNowUrl: string;
  knowMoreLink: string;
}

const CouponCard: React.FC<CouponCardProps> = ({
  title,
  couponCode,
  validTill,
  buyNowUrl,
  knowMoreLink,
}) => {
  const couponBgColor = 'bg-blue-50 border-blue-200';
  const couponTextColor = 'text-blue-600';

  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex justify-between">
        <span>{title}</span>
        <span
          className="text-sm hover:underline cursor-pointer text-brand-700 sm:pt-1"
          onClick={() => {
            window.open(knowMoreLink, '_blank');
          }}
        >
          Know more
        </span>
      </h3>
      <div className="mb-4">
        <div className={`${couponBgColor} border rounded-lg p-4 mb-3`}>
          <div className="text-sm font-semibold text-gray-700">
            COUPON:{' '}
            <span className={`${couponTextColor} font-bold`}>{couponCode}</span>
          </div>
          <p className="text-sm text-gray-600 mt-1">{validTill}</p>
        </div>
        <ButtonWithAnchor
          buttonText="Buy Now"
          buttonLink={buyNowUrl}
          trackLabel="itr_organic_2025_coupon_code_page"
          buttonVariant={ButtonVariants.bluefilled}
        />
      </div>
    </div>
  );
};

export default CouponCard;
